import React, { useEffect, useState } from 'react';
import { sort } from 'ramda';
import { RouteComponentProps } from 'react-router-dom';
import queryString from 'query-string';

import { Dashboard } from 'components/Layout';
import api from 'api/api';
import StoreProvider from 'components/StoreProvider/StoreProvider';
import { OrganizationsState } from 'store/modules/organizations/organizations';
import Organizations from 'components/Organizations/Organizations';
import EmptyPlaceholder from 'components/EmptyPlaceholder/EmptyPlaceholder';
import AdminMenu from 'components/AdminMenu/AdminMenu';
import { useFormatMessage } from 'components/IntlProvider';

const { connect, selectors, actions } = StoreProvider;

interface OrganizationsListProps extends RouteComponentProps {
  organizations: OrganizationsState;
  setOrganizations: (payload: any) => void;
}

const OrganizationsList = ({
  organizations,
  setOrganizations,
  location,
}: OrganizationsListProps) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const t = useFormatMessage();

  const parsedSearch = queryString.parse(location.search);

  useEffect(() => {
    setIsLoaded(false);
    api.resources
      .getOrganizations(
        parsedSearch as {
          limit: string;
          offset: string;
          search: string;
        }
      )
      .then(({ data }) => {
        setOrganizations(data);
      })
      .finally(() => {
        setIsLoaded(true);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search]);

  const getPageNumber = () => {
    if (parsedSearch.offset && !Array.isArray(parsedSearch.offset)) {
      return parseInt(parsedSearch.offset, 10) / 20 + 1;
    }

    return 0;
  };
  return (
    <Dashboard
      title={t('organizations.title', 'Organizations')}
      location={location}
    >
      <AdminMenu />

      <EmptyPlaceholder
        isLoaded={isLoaded}
        hasValues={organizations.list.length > 0}
        withLoader
      >
        <Organizations
          list={sort((a: any, b: any) => a.id - b.id)(organizations.list)}
          count={organizations.count}
          currentPage={getPageNumber()}
        />
      </EmptyPlaceholder>
    </Dashboard>
  );
};

export default connect(
  (state) => ({
    organizations: selectors.organizationsSelectors.organizations(state),
  }),
  {
    setOrganizations: actions.organizationsActions.setOrganizations,
  }
)(OrganizationsList);
